import { render, staticRenderFns } from "./CombinedFormUserReport.vue?vue&type=template&id=4b716e57"
import script from "./CombinedFormUserReport.vue?vue&type=script&lang=js"
export * from "./CombinedFormUserReport.vue?vue&type=script&lang=js"
import style0 from "./CombinedFormUserReport.vue?vue&type=style&index=0&id=4b716e57&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/CoreProductivity.Backoffice.Mobile/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b716e57')) {
      api.createRecord('4b716e57', component.options)
    } else {
      api.reload('4b716e57', component.options)
    }
    module.hot.accept("./CombinedFormUserReport.vue?vue&type=template&id=4b716e57", function () {
      api.rerender('4b716e57', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/pages/form/CombinedFormUserReport.vue"
export default component.exports